import TileMinedLogic from "../../../logic/TileMinedLogic";
import { Settings } from "../../../Settings";
import Character from "../../character/Character";
import WorldGrid from "../../grid/WorldGrid";
import Vector from "../../math/Vector";
import SkillUtil from "../SkillUtil";

const twoPi = 2 * Math.PI;
const orbitRadiansPerSecond = Math.PI / 50;

export default class OrbitPair {
    /**
     * @param {WorldGrid} worldGrid
     * @param {TileMinedLogic} tileMinedLogic
     * @param {Character} character 
     * @param {number} maxPixelRange
     */
    constructor(worldGrid, tileMinedLogic, character, maxPixelRange) {

        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;
        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;
        /**
         * @constant
         * @type {Character}
         */
        this.character = character;

        /**
         * @constant
         * @type {Vector}
         */
        this.center = new Vector(0, 0);

        /**
         * @type {number}
         */
        this.range = 0;

        /**
         * @type {number}
         */
        this.radians = 0;

        /**
         * @constant
         * @type {Vector}
         */
        this.endPoint = new Vector(0, 0);

        this.initialize(maxPixelRange);
    }

    /**
     * @param {number} maxPixelRange 
     */
    onSkillActivation(maxPixelRange) {
        this.initialize(maxPixelRange);
    }

    /**
     * @private
     * @param {number} maxPixelRange 
     */
    initialize(maxPixelRange) {
        // The character is always at the center
        this.center.copy(this.character.position.worldCoordinateOrigin);
        this.center.addXY(Settings.tile.halfSize, Settings.tile.halfSize);

        this.range = maxPixelRange;

        SkillUtil.projectPosition(this.center, this.range, this.radians, this.endPoint);
    }

    /**
     * @param {number} frameTimeRatio 
     */
    updateForFrame(frameTimeRatio) {
        // The character is always at the center
        this.center.copy(this.character.position.worldCoordinateOrigin);
        this.center.addXY(Settings.tile.halfSize, Settings.tile.halfSize);

        this.radians += (frameTimeRatio * orbitRadiansPerSecond);
        if (this.radians > twoPi) {
            this.radians -= twoPi;
        }

        // Update the end point
        SkillUtil.projectPosition(this.center, this.range, this.radians, this.endPoint);

        const orbTile = this.worldGrid.findGridTile(this.endPoint);
        if (orbTile) {
            if (!orbTile.lighting.everVisibleToCharacter) {
                orbTile.markTileAsCurrentlyVisible();
            }
        
            if (!orbTile.open) {
                this.tileMinedLogic.orbitTileForFrame(orbTile, frameTimeRatio);
            }
        }
    }
}